<template>
    <Select v-model="selectedLanguage" :options="languages" optionLabel="name" :placeholder="selectedLanguage.name" class="language-switcher" :class="type == 'login' ? 'login-switcher' : ''">
        <template #value="slotProps">
            <div v-if="slotProps.value" class="selected-wrapper">
                <Icon :name="slotProps.value.icon" class="flag" />

                <div>{{ slotProps.value.name }}</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
        </template>
        <template #option="slotProps">
            <div class="option-wrapper">
                <Icon :name="slotProps.option.icon" />
                <div>{{ slotProps.option.name }}</div>
            </div>
        </template>
    </Select>
</template>

<script setup>
import axios from 'axios';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { locales } from '../../locales';
import { useAuthStore } from '@stores/AuthStore';

const { type } = defineProps({
    type: {
        type: String,
    },
});

const authStore = useAuthStore();
const { locale } = useI18n({ useScope: 'global' });
const languages = ref(locales);

const selectedLanguage = ref(languages.value.find((lang) => lang.code == locale.value) ?? languages.value[0]);

const switchLang = async () => {
    try {
        await axios.get('https://proctoring-api.univora.uz/services/platon-core/user-locale', {
            params: {
                locale: locale.value,
            },
            headers: {
                Authorization: `Bearer ${authStore.userToken}`,
                'Content-Type': 'application/json',
            },
        });
        authStore.changeLocale(locale.value);
    } catch (error) {
        console.error(error);
    }
};

watch(
    () => selectedLanguage.value,
    (newValue) => {
        locale.value = newValue.code;
        if (authStore.isAuthenticated) {
            switchLang();
        }
    }
);
</script>

<style scoped>
.language-switcher {
    @apply border-0 shadow-none;
    background: none;
}

.login-switcher .selected-wrapper,
:deep.login-switcher .p-select-dropdown {
    @apply text-black;
}

.selected-wrapper,
.option-wrapper {
    @apply flex items-center gap-x-2 text-sm text-gray-900;
}
</style>
